export enum QuoteFilterOption {
  TypeOfBuy = 't',
  Requestor = 'r',
  Employee = 'e',
  Status = 's',
  Region = 'rg',
}
